module.exports = __webpack_public_path__ + "img/Search.8dbc8a97.svg";